// apps/web/services/favoritesService.ts
import { productService } from '@cabukaka/services';
import { Product } from '@cabukaka/types';

const STORAGE_KEY = 'favorites_ids';

export const favoriteService = {
  // Récupérer les IDs
  getIds: (): string[] => {
    if (typeof window === 'undefined') return [];
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return [];
    try {
      return JSON.parse(saved);
    } catch {
      return [];
    }
  },

  // Sauvegarder les IDs
  saveIds: (ids: string[]): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  },

  // Ajouter un ID
  addId: (productId: string): void => {
    const ids = favoriteService.getIds();
    if (!ids.includes(productId)) {
      favoriteService.saveIds([...ids, productId]);
    }
  },

  // Retirer un ID
  removeId: (productId: string): void => {
    const ids = favoriteService.getIds();
    favoriteService.saveIds(ids.filter(id => id !== productId));
  },

  // Vérifier si favori
  isFavorite: (productId: string): boolean => {
    return favoriteService.getIds().includes(productId);
  },

  // Récupérer les produits favoris (données fraîches)
  getFavoritesProducts: async (): Promise<Product[]> => {
    const ids = favoriteService.getIds();
    if (ids.length === 0) return [];
    
    const products = await productService.getProductsByIds(ids);
    return products;
  },

  // Compter
  getCount: (): number => {
    return favoriteService.getIds().length;
  },

  // Vider
  clear: (): void => {
    favoriteService.saveIds([]);
  }
};